// Utility for stamping emails in Outlook add-in
// Stamps CustomProperties (UWWBID) for drafts and all emails, and internetHeaders (X-UWWBID) for non-drafts if available
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function stampEmailWithWorkbenchId(item, workbenchId, DebugService) {
    return __awaiter(this, void 0, void 0, function* () {
        DebugService.debug('Starting email stamping with workbenchId:', workbenchId);
        DebugService.debug('Item type:', item ? 'exists' : 'null');
        DebugService.debug('Item has itemId:', !!(item === null || item === void 0 ? void 0 : item.itemId));
        // For drafts, only stamp CustomProperties
        if (!item || !item.itemId) {
            DebugService.debug('Stamping draft email: CustomProperties only');
            return new Promise((resolve) => {
                if (typeof item.loadCustomPropertiesAsync === 'function') {
                    item.loadCustomPropertiesAsync((result) => {
                        if (result.status === Office.AsyncResultStatus.Succeeded) {
                            const cp = result.value;
                            cp === null || cp === void 0 ? void 0 : cp.set('UWWBID', workbenchId);
                            cp === null || cp === void 0 ? void 0 : cp.saveAsync((saveResult) => {
                                if (saveResult.status === Office.AsyncResultStatus.Succeeded) {
                                    DebugService.debug('Stamped CustomProperties UWWBID on draft:', workbenchId);
                                }
                                else {
                                    DebugService.warn('Failed to save CustomProperties UWWBID on draft:', saveResult.error);
                                }
                                resolve();
                            });
                        }
                        else {
                            DebugService.warn('Failed to load CustomProperties for stamping draft:', result.error);
                            resolve();
                        }
                    });
                }
                else {
                    DebugService.warn('loadCustomPropertiesAsync not available for stamping draft');
                    resolve();
                }
            });
        }
        // For non-drafts, stamp internetHeaders if possible, and always stamp CustomProperties
        return new Promise((resolve, reject) => {
            if (item.internetHeaders && typeof item.internetHeaders.setAsync === 'function') {
                item.internetHeaders.setAsync({ 'X-UWWBID': workbenchId }, (result) => {
                    if (result.status === Office.AsyncResultStatus.Succeeded) {
                        DebugService.debug('Stamped X-UWWBID header:', workbenchId);
                    }
                    else {
                        DebugService.warn('Failed to stamp X-UWWBID header:', result.error);
                    }
                    // Always stamp CustomProperties for redundancy
                    if (typeof item.loadCustomPropertiesAsync === 'function') {
                        item.loadCustomPropertiesAsync((cpResult) => {
                            if (cpResult.status === Office.AsyncResultStatus.Succeeded) {
                                const cp = cpResult.value;
                                cp === null || cp === void 0 ? void 0 : cp.set('UWWBID', workbenchId);
                                cp === null || cp === void 0 ? void 0 : cp.saveAsync((saveResult) => {
                                    if (saveResult.status === Office.AsyncResultStatus.Succeeded) {
                                        DebugService.debug('Stamped CustomProperties UWWBID:', workbenchId);
                                    }
                                    else {
                                        DebugService.warn('Failed to save CustomProperties UWWBID:', saveResult.error);
                                    }
                                    resolve();
                                });
                            }
                            else {
                                DebugService.warn('Failed to load CustomProperties for stamping:', cpResult.error);
                                resolve();
                            }
                        });
                    }
                    else {
                        DebugService.warn('loadCustomPropertiesAsync not available for stamping');
                        resolve();
                    }
                });
            }
            else if (typeof item.loadCustomPropertiesAsync === 'function') {
                // If headers not available, stamp custom properties only
                item.loadCustomPropertiesAsync((cpResult) => {
                    if (cpResult.status === Office.AsyncResultStatus.Succeeded) {
                        const cp = cpResult.value;
                        cp === null || cp === void 0 ? void 0 : cp.set('UWWBID', workbenchId);
                        cp === null || cp === void 0 ? void 0 : cp.saveAsync((saveResult) => {
                            if (saveResult.status === Office.AsyncResultStatus.Succeeded) {
                                DebugService.debug('Stamped CustomProperties UWWBID:', workbenchId);
                            }
                            else {
                                DebugService.warn('Failed to save CustomProperties UWWBID:', saveResult.error);
                            }
                            resolve();
                        });
                    }
                    else {
                        DebugService.warn('Failed to load CustomProperties for stamping:', cpResult.error);
                        resolve();
                    }
                });
            }
            else {
                DebugService.warn('Neither internetHeaders nor loadCustomPropertiesAsync available for stamping');
                resolve();
            }
        });
    });
}
